import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

const defaultMeta = [
  { charSet: 'utf-8' },
  { name: 'format-detection', content: 'telephone=no' },
  { httpEquiv: 'x-ua-compatible', content: 'ie=edge' },
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, maximum-scale=2',
  },
]

export default ({ children, ...props }) => {
  const data = useStaticQuery(graphql`
    query HelmetQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <html lang='en' />
      <title>{`${props.title} | ${data.site.siteMetadata.title}`}</title>
      {defaultMeta.map((metaProps, i) => (
        <meta key={i} {...metaProps} />
      ))}
      {children}
    </>
  )
}
